import { EmptyState, Loading } from '@gorila-shared-ui/components';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { useRecoilValue } from 'recoil';
import { isPublicPageState } from '../../storage/app';
import { filteredCurrentStateIdsState, loadingCurrentStatesState } from '../../storage/currentStates';
import CurrentStateCard from './CurrentStateCard';
import CurrentStateFilters from './CurrentStateFilters';
import CurrentStatesInfo from './CurrentStatesInfo';

function CurrentStateList() {
  const filteredCurrentStateIds = useRecoilValue(filteredCurrentStateIdsState);
  const loadingCurrentStates = useRecoilValue(loadingCurrentStatesState);
  const isPublicPage = useRecoilValue(isPublicPageState);

  return (
    <>
      {!filteredCurrentStateIds && !loadingCurrentStates && (
        <EmptyState title={isPublicPage ? 'No se encontraron unidades' : 'Todavía no cuentas con unidades'} />
      )}
      {!filteredCurrentStateIds && loadingCurrentStates && <Loading />}
      {filteredCurrentStateIds && (
        <>
          <CurrentStateFilters />
          {!!filteredCurrentStateIds.length && (
            <div style={{ flex: 1 }}>
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    height={height ? height - 2 : 500}
                    width={width ? width : 500}
                    itemData={filteredCurrentStateIds}
                    itemCount={filteredCurrentStateIds.length}
                    itemSize={(_) => (width && width > 550 ? 192 : 220)}
                  >
                    {CurrentStateCard}
                  </List>
                )}
              </AutoSizer>
            </div>
          )}
          {!filteredCurrentStateIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
          <CurrentStatesInfo />
        </>
      )}
    </>
  );
}

export default CurrentStateList;
